(() => {
  if (window.yukiwaPageInit) {
    window.yukiwaPageInit(document);
    return;
  }
  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase().trim();
  function init(context) {
    context.querySelectorAll('[data-yukiwa-page]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const search = root.querySelector('[data-search]');
      if (!search) return;
      const category = root.querySelector('[data-category-filter]');
      const cards = [...root.querySelectorAll('[data-product-id]')];
      const groups = [...root.querySelectorAll('[data-product-group]')];
      const count = root.querySelector('[data-count]');
      const empty = root.querySelector('[data-empty]');
      const zh = root.dataset.locale === 'zh';
      const current = new URL(window.location.href);
      const searchable = new Map(cards.map(card => [card, normalize(card.dataset.search)]));
      function update() {
        const words = normalize(search.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        for (const card of cards) {
          const match = (!category || !category.value || card.dataset.category === category.value)
            && words.every(word => searchable.get(card).includes(word));
          card.hidden = !match;
          if (match) visible += 1;
        }
        for (const group of groups) {
          group.hidden = ![...group.querySelectorAll('[data-product-id]')].some(card => !card.hidden);
        }
        count.textContent = zh ? `顯示 ${visible} / ${cards.length} 件商品` : `${visible} of ${cards.length} ${cards.length === 1 ? 'item' : 'items'}`;
        empty.hidden = visible !== 0;
      }
      search.addEventListener('input', update);
      search.addEventListener('search', update);
      if (category) {
        category.addEventListener('change', update);
        const initial = current.searchParams.get('category');
        if ([...category.options].some(option => option.value === initial)) category.value = initial;
        root.querySelectorAll('[data-category-link]').forEach(link => {
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            category.value = link.dataset.categoryLink;
            search.value = '';
            update();
            root.querySelector('#yukiwa-products').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            search.focus({ preventScroll: true });
          });
        });
      }
      root.querySelectorAll('[data-yukiwa-link]').forEach(link => {
        if (link.getAttribute('href').startsWith('#')) return;
        const destination = new URL(link.getAttribute('href'), current);
        for (const key of ['preview_theme_id', '_fd', 'pb', 'preview_key']) {
          if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
        }
        link.setAttribute('href', destination.pathname + destination.search + destination.hash);
      });
      const localeForm = root.querySelector('[data-yukiwa-language]')?.closest('form');
      if (localeForm) {
        const returnTo = localeForm.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = current.pathname + current.search + current.hash;
      }
      update();
    });
  }
  window.yukiwaPageInit = init;
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
